import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@techsoftware/happay-widgets/Snackbar';

function CustomSnackbar(props) {
  const { open, position, message, type, showIcon, closeSnackBar } = props;
  return (
    <Snackbar
      message={message}
      showSnackbar={open}
      position={position}
      id="snackbar"
      type={type}
      className="snackbar-top-z-index"
      showIcon={showIcon}
      onClose={closeSnackBar}
    />
  );
}

export default memo(CustomSnackbar);

CustomSnackbar.propTypes = {
  open: PropTypes.bool,
  position: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string,
  showIcon: PropTypes.bool,
};

CustomSnackbar.defaultProps = {
  open: false,
  position: 'left-bottom',
  message: 'Somthing Went Wrong!',
  type: 'success',
  showIcon: true,
};
